import {
  Clock3Icon,
  ShuffleIcon,
  UsersIcon,
  NotebookPenIcon,
  MessageCircleQuestionIcon,
  RepeatIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface PainPoint {
  icon: LucideIcon
  quote: string
  detail: string
}

export const painPoints: PainPoint[] = [
  {
    icon: Clock3Icon,
    quote: '«La sera prima preparo ancora la lezione del giorno dopo.»',
    detail: 'Ogni classe ti costa un’ora di preparazione che nessuno ti paga.',
  },
  {
    icon: ShuffleIcon,
    quote: '«Ogni lezione è diversa e non so più cosa ho già fatto.»',
    detail: 'Senza un repertorio scritto il percorso delle allieve resta casuale.',
  },
  {
    icon: UsersIcon,
    quote: '«Nella stessa classe ho principianti e avanzate.»',
    detail: 'Ti manca una variante pronta per alzare o abbassare il livello al volo.',
  },
  {
    icon: NotebookPenIcon,
    quote: '«Le mie schede sono appunti sparsi su un quaderno.»',
    detail: 'Non hai nulla di presentabile da lasciare in mano a chi si allena con te.',
  },
  {
    icon: MessageCircleQuestionIcon,
    quote: '«Un’allieva mi chiede a cosa serve questo esercizio e mi blocco.»',
    detail: 'Ti servono benefici e indicazioni già formulati, chiari e professionali.',
  },
  {
    icon: RepeatIcon,
    quote: '«Ripeto sempre le stesse quattro sequenze.»',
    detail: 'Le allieve si annoiano e dopo qualche mese smettono di rinnovare.',
  },
]
